import React, { useEffect, } from 'react';
import useDraft from '../../components/common/autoSaveDraftMsg/useDraft';
import translations from '../../config/TranslateFile.jsx'
import { EventLog } from '../../components/common/EventLog/EventLog.jsx';
import { useDispatch } from 'react-redux';
import { getStoredValue } from '../../_helpers/storagehelper.js';

const Support = () => {
  // Auto Draft save
  const { setIsSaveDraftModified } = useDraft();
  const dispatch = useDispatch();
  const currentLang = translations();

  useEffect(() => {
    const savedDraft = getStoredValue("draft");
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);


  const handleEventlog = () => {
    const infoMessage = `Redirect into Contact us Page - From Support Menu `;
    const redirectURL = "http://www.inmateinbox.com/contact-us/";
    const Response = "---";
    const Status = "Redirected into Contact us Page - http://www.inmateinbox.com/contact-us/";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
  }

  return (
    <div className="flex-grow-1 overflow-hidden height-100">
      <div>
        <div className="header-title">
          <h5>
            {/* <i className='fa-solid fa-headset me-2'></i> */}
            {currentLang?.Support}
          </h5>
        </div>
      </div>
      {/* Main Content Section */}
      <div className="card border-radius-all shadow-sm">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <h3 className="mb-4 text-start font-size-15">
                {currentLang?.SupportPage?.SupportContent}
              </h3>
              <div className="alert-blue align-items-center mb-3 font-size-15">
                {currentLang?.SupportPage?.SupportDescrption}{" "}
                <span>
                  <a
                    href="http://www.inmateinbox.com/contact-us/"
                    id="ContentPlaceHolder1_anchrRedirection"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => handleEventlog()}
                  >
                    www.inmateinbox.com
                  </a>
                </span>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Support);
